import { FreeEntryData } from "../../entities";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../utils/ProtocolTypeUtils";
import OldRecordsParser from './OldRecordsParser';
const FREE_ENTRY_DATA_TAG = 'FreeEntry';
export default class FreeEntryParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.FREE_ENTRY, FIXED_PROTOCOL_CONTENT_TYPE_IDS.FREE_ENTRY, FREE_ENTRY_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            title: 'title',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new FreeEntryData(props.title, props.freeText);
    }
}
//# sourceMappingURL=FreeEntryParser.js.map